export default __webpack_public_path__ + "9b8604b1aac371fe2ca7d3be55586cc9.svg";